import { SettingsGlobal } from 'entities/Settings/interfaces';
import {
  FORCE_SAVE_GLOBAL_SET,
  GET_GLOBAL_SETTINGS_ERROR,
  GET_GLOBAL_SETTINGS_REQUEST,
  GET_GLOBAL_SETTINGS_SUCCESS,
  PUT_GLOBAL_SETTINGS_ERROR,
  PUT_GLOBAL_SETTINGS_REQUEST,
  PUT_GLOBAL_SETTINGS_SUCCESS,
  SET_SAVE_GLOBAL_SET,
} from './constants';

export const getGlobalSetRequest = () => ({
  type: GET_GLOBAL_SETTINGS_REQUEST,
});

export const getGlobalSetError = (error: Error | null) => ({
  type: GET_GLOBAL_SETTINGS_ERROR,
  payload: error,
});

export const getGlobalSetSuccess = (settings: SettingsGlobal) => ({
  type: GET_GLOBAL_SETTINGS_SUCCESS,
  payload: settings,
});

export const putGlobalSetRequest = (settings: SettingsGlobal) => ({
  type: PUT_GLOBAL_SETTINGS_REQUEST,
  payload: settings,
});

export const putGlobalSetError = (error: Error | null) => ({
  type: PUT_GLOBAL_SETTINGS_ERROR,
  payload: error,
});

export const putGlobalSetSuccess = () => ({
  type: PUT_GLOBAL_SETTINGS_SUCCESS,
});

export const saveGlobalSet = (save: boolean) => ({
  type: SET_SAVE_GLOBAL_SET,
  payload: save,
});

export const forceSaveGlobalSet = (forceSave: boolean) => ({
  type: FORCE_SAVE_GLOBAL_SET,
  payload: forceSave,
});

export type Actions =
  | ReturnType<typeof getGlobalSetRequest>
  | ReturnType<typeof getGlobalSetSuccess>
  | ReturnType<typeof getGlobalSetError>
  | ReturnType<typeof putGlobalSetRequest>
  | ReturnType<typeof putGlobalSetSuccess>
  | ReturnType<typeof putGlobalSetError>
  | ReturnType<typeof forceSaveGlobalSet>
  | ReturnType<typeof saveGlobalSet>;
